import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractComponent } from '@components';
import { ActionResultList, Country, EventItem, EventItemType, Lookups } from "@model";
import { PublicEventsService } from '@services';
import { EVENT_DETAILS } from 'src/app/app-routing.module';

@Component({
  selector: 'app-user-profile-wish-list-tab',
  templateUrl: './user-profile-wish-list-tab.component.html',
  styleUrls: ['./user-profile-wish-list-tab.component.scss']
})
export class UserProfileWishListTabComponent extends AbstractComponent implements OnInit {
  @Input() favoriteItems: EventItem[] = [];
  @Input() countries: Country[] = [];
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() isOnWishList = true;

  calendarType: EventItemType = EventItemType.MY_FAVORITE;
  EventItemType = EventItemType;
  isLoading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private publicEventService: PublicEventsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribeToFavoritesChange();
  }

  subscribeToFavoritesChange(): void {
    this.subscriptions.push(
      this.publicEventService.favoriteEvents.subscribe((value: ActionResultList<EventItem[], number> | null) => {
        this.favoriteItems = value?.result ?? [];
      })
    );
  }

  goToEventDetailsPage(item: EventItem) {
    this.router.navigate([EVENT_DETAILS], {
      relativeTo: this.route,
      queryParams: { eventId: item.id }
    });
  }
}
